/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TroveManager, TroveManagerInterface } from "../TroveManager";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_baseRate",
        type: "uint256",
      },
    ],
    name: "BaseRateUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newBorrowerOperationsAddress",
        type: "address",
      },
    ],
    name: "BorrowerOperationsAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_collSurplusPoolAddress",
        type: "address",
      },
    ],
    name: "CollSurplusPoolAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_gasPoolAddress",
        type: "address",
      },
    ],
    name: "GasPoolAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_L_ETH",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_L_VSTDebt",
        type: "uint256",
      },
    ],
    name: "LTermsUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_lastFeeOpTime",
        type: "uint256",
      },
    ],
    name: "LastFeeOpTimeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_liquidatedDebt",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_liquidatedColl",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_collGasCompensation",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_VSTGasCompensation",
        type: "uint256",
      },
    ],
    name: "Liquidation",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_attemptedVSTAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_actualVSTAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_AssetSent",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_AssetFee",
        type: "uint256",
      },
    ],
    name: "Redemption",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address",
      },
    ],
    name: "SortedTrovesAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_stabilityPoolAddress",
        type: "address",
      },
    ],
    name: "StabilityPoolAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_totalStakesSnapshot",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_totalCollateralSnapshot",
        type: "uint256",
      },
    ],
    name: "SystemSnapshotsUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_newTotalStakes",
        type: "uint256",
      },
    ],
    name: "TotalStakesUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_newIndex",
        type: "uint256",
      },
    ],
    name: "TroveIndexUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_debt",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_coll",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "operation",
        type: "uint8",
      },
    ],
    name: "TroveLiquidated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_L_ETH",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_L_VSTDebt",
        type: "uint256",
      },
    ],
    name: "TroveSnapshotsUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_debt",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_coll",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stake",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "operation",
        type: "uint8",
      },
    ],
    name: "TroveUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_VSTAStakingAddress",
        type: "address",
      },
    ],
    name: "VSTAStakingAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newVSTTokenAddress",
        type: "address",
      },
    ],
    name: "VSTTokenAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newAddress",
        type: "address",
      },
    ],
    name: "VaultParametersBaseChanged",
    type: "event",
  },
  {
    inputs: [],
    name: "BETA",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DECIMAL_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ETH_REF_ADDRESS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "L_ASSETS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "L_VSTDebts",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINUTE_DECAY_FACTOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SECONDS_IN_ONE_MINUTE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "TroveOwners",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "Troves",
    outputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "debt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "coll",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stake",
        type: "uint256",
      },
      {
        internalType: "enum ITroveManager.Status",
        name: "status",
        type: "uint8",
      },
      {
        internalType: "uint128",
        name: "arrayIndex",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "addTroveOwnerToArray",
    outputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "applyPendingRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "baseRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_troveArray",
        type: "address[]",
      },
    ],
    name: "batchLiquidateTroves",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "borrowerOperationsAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    name: "checkRecoveryMode",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "closeTrove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "decayBaseRateFromBorrowing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_collDecrease",
        type: "uint256",
      },
    ],
    name: "decreaseTroveColl",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_debtDecrease",
        type: "uint256",
      },
    ],
    name: "decreaseTroveDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_VSTDebt",
        type: "uint256",
      },
    ],
    name: "getBorrowingFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_VSTDebt",
        type: "uint256",
      },
    ],
    name: "getBorrowingFeeWithDecay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getBorrowingRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getBorrowingRateWithDecay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    name: "getCurrentICR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "getEntireDebtAndColl",
    outputs: [
      {
        internalType: "uint256",
        name: "debt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "coll",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "pendingVSTDebtReward",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "pendingAssetReward",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getEntireSystemColl",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemColl",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getEntireSystemDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemDebt",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "getNominalICR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "getPendingAssetReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "getPendingVSTDebtReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_assetDraw",
        type: "uint256",
      },
    ],
    name: "getRedemptionFeeWithDecay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getRedemptionRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getRedemptionRateWithDecay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    name: "getTCR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "getTroveColl",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "getTroveDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_index",
        type: "uint256",
      },
    ],
    name: "getTroveFromTroveOwnersArray",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getTroveOwnersCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "getTroveStake",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "getTroveStatus",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "hasPendingRewards",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_collIncrease",
        type: "uint256",
      },
    ],
    name: "increaseTroveColl",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_debtIncrease",
        type: "uint256",
      },
    ],
    name: "increaseTroveDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lastETHError_Redistribution",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lastFeeOperationTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lastVSTDebtError_Redistribution",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "liquidate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_n",
        type: "uint256",
      },
    ],
    name: "liquidateTroves",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_VSTamount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_firstRedemptionHint",
        type: "address",
      },
      {
        internalType: "address",
        name: "_upperPartialRedemptionHint",
        type: "address",
      },
      {
        internalType: "address",
        name: "_lowerPartialRedemptionHint",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_partialRedemptionHintNICR",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxIterations",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxFeePercentage",
        type: "uint256",
      },
    ],
    name: "redeemCollateral",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "removeStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "rewardSnapshots",
    outputs: [
      {
        internalType: "uint256",
        name: "asset",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "VSTDebt",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_stabilityPoolManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_gasPoolAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_collSurplusPoolAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vstTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vstaStakingAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vestaParamsAddress",
        type: "address",
      },
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_num",
        type: "uint256",
      },
    ],
    name: "setTroveStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vaultParams",
        type: "address",
      },
    ],
    name: "setVestaParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "sortedTroves",
    outputs: [
      {
        internalType: "contract ISortedTroves",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stabilityPoolManager",
    outputs: [
      {
        internalType: "contract IStabilityPoolManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "totalCollateralSnapshot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "totalStakes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "totalStakesSnapshot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getSystemTotalUnpaidInterest",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "getUnpaidInterestOfUser",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "updateStakeAndTotalStakes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
    ],
    name: "updateTroveRewardSnapshots",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vestaParams",
    outputs: [
      {
        internalType: "contract IVestaParameters",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vstToken",
    outputs: [
      {
        internalType: "contract IVSTToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vstaStaking",
    outputs: [
      {
        internalType: "contract IVSTAStaking",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TroveManagerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TroveManagerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TroveManager__factory extends ContractFactory {
  constructor(...args: TroveManagerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<TroveManager> {
    return super.deploy(overrides || {}) as Promise<TroveManager>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): TroveManager {
    return super.attach(address) as TroveManager;
  }
  override connect(signer: Signer): TroveManager__factory {
    return super.connect(signer) as TroveManager__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TroveManagerInterface {
    return new utils.Interface(_abi) as TroveManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TroveManager {
    return new Contract(address, _abi, signerOrProvider) as TroveManager;
  }
}
